'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosPrinterOutline = function IoIosPrinterOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm33.5 8.8c1.4 0 2.5 1 2.5 2.4v12.4c0 1.4-1.1 2.5-2.5 2.5h-3.7v8.9h-20v-8.9h-3.8c-1.4 0-2.5-1.1-2.5-2.5v-12.4c0-1.4 1.1-2.4 2.5-2.4h2.5v-3.8h22.5v3.8h2.5z m-23.7-2.5v2.5h20v-2.5h-20z m18.7 27.5v-15h-17.5v15h17.5z m6.3-10.2v-12.4c0-0.7-0.6-1.2-1.3-1.2h-27.5c-0.7 0-1.2 0.5-1.2 1.2v12.4c0 0.7 0.5 1.2 1.2 1.2h3.8v-7.3h20v7.3h3.7c0.7 0 1.3-0.5 1.3-1.2z' })
        )
    );
};

exports.default = IoIosPrinterOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-printer-outline.js
// module id = 2256
// module chunks = 0